export default __webpack_public_path__ + "static/media/avatar19-cat.acd67877.png";